import { message } from "antd";
import config from "../../../config.json";
import {
  getRequest,
  postRequest,
  patchRequest,
  formatRequestError,
} from "../../../utils/requests";

export const fetchEntities = ({
  setEntities = () => {},
  setIsLoading = () => {},
  setToken = () => {},
}) => {
  const url = `${config.service}/api/entity`;

  const response = getRequest(url, {});

  response
    .then((data) => {
 
      
      setEntities(data.data);
      console.log('fetch', data.data)
    })
    .catch((err) => console.warn("Kepler: не удалось загрузить данные", err?.response?.status || err?.message))
    .finally(() => {
      setIsLoading(false);
    });
  
    
};

export const createEntity = (body, onFinish) => {
  const hideLoadingMsg = message.loading("Сохраняется", 0);

  const url = `${config.service}/api/entity`;

  const response = postRequest(url, body);

  response
    .then(() => {
      message.success("Юр. лицо успешно создан", 2);

      onFinish();
    })
    .catch((err) => {
      message.error(formatRequestError("Не удалось сохранить юр.лицо", err), 2);
    })
    .finally(() => {
      hideLoadingMsg();
    });
};

export const updateEntity = async ({
  entityId = "",
  body = {},
  setIsLoading = () => {},
}) => {
  const hideLoadingMsg = message.loading("Загрузка...", 0);

  await patchRequest(`${config.service}/api/entity/${entityId}`, body)
    .catch((err) => {
      message.error(formatRequestError("Ошибка при обновлении", err), 3);
    })
    .finally(() => {
      setIsLoading(false);
    });


  await patchRequest(
    `${config.service}/api/permission/entity/${entityId}`,
    body.permission
  )
    .then(() => {
      message.success("Обновлено", 3);
    })
    .finally(() => {
      hideLoadingMsg();
    });
};
